import React, { useState, useEffect } from 'react';
import "../../styles/style.css";
import { MdOutlineNavigateNext } from "react-icons/md";

const ImageCarousel = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      nextImage();
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentImageIndex]);

  return (
    <div>
      <div className="infobar-image">
        <img
          src={images[currentImageIndex]}
          alt={`Slide ${currentImageIndex + 1}`}
        />
        <button onClick={nextImage}><MdOutlineNavigateNext style={{ color: '#fff', fontSize: '40px' }}/></button>
      </div>

    </div>
  );
};

export default ImageCarousel;